/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification
 */
export interface FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification {
    /**
     *
     * @type {string}
     * @memberof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification
     */
    id: string;
    /**
     *
     * @type {string}
     * @memberof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification
     */
    checked_at: string;
    /**
     *
     * @type {boolean}
     * @memberof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification
     */
    npi_found: boolean;
    /**
     *
     * @type {boolean}
     * @memberof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification
     */
    is_eligible_for_home_health?: boolean | null;
    /**
     *
     * @type {boolean}
     * @memberof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification
     */
    is_eligible_for_hospice?: boolean | null;
    /**
     *
     * @type {boolean}
     * @memberof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification
     */
    is_eligible_for_part_b?: boolean | null;
    /**
     *
     * @type {boolean}
     * @memberof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification
     */
    is_eligible_for_durable_medical_equipment?: boolean | null;
    /**
     *
     * @type {boolean}
     * @memberof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification
     */
    is_eligible_for_power_mobility_devices?: boolean | null;
}

/**
 * Check if a given object implements the FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification interface.
 */
export function instanceOfFindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "checked_at" in value;
    isInstance = isInstance && "npi_found" in value;

    return isInstance;
}

export function FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerificationFromJSON(json: any): FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification {
    return FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerificationFromJSONTyped(json, false);
}

export function FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'id': json['id'],
        'checked_at': json['checked_at'],
        'npi_found': json['npi_found'],
        'is_eligible_for_home_health': !exists(json, 'is_eligible_for_home_health') ? undefined : json['is_eligible_for_home_health'],
        'is_eligible_for_hospice': !exists(json, 'is_eligible_for_hospice') ? undefined : json['is_eligible_for_hospice'],
        'is_eligible_for_part_b': !exists(json, 'is_eligible_for_part_b') ? undefined : json['is_eligible_for_part_b'],
        'is_eligible_for_durable_medical_equipment': !exists(json, 'is_eligible_for_durable_medical_equipment') ? undefined : json['is_eligible_for_durable_medical_equipment'],
        'is_eligible_for_power_mobility_devices': !exists(json, 'is_eligible_for_power_mobility_devices') ? undefined : json['is_eligible_for_power_mobility_devices'],
    };
}

export function FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerificationToJSON(value?: FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'id': value.id,
        'checked_at': value.checked_at,
        'npi_found': value.npi_found,
        'is_eligible_for_home_health': value.is_eligible_for_home_health,
        'is_eligible_for_hospice': value.is_eligible_for_hospice,
        'is_eligible_for_part_b': value.is_eligible_for_part_b,
        'is_eligible_for_durable_medical_equipment': value.is_eligible_for_durable_medical_equipment,
        'is_eligible_for_power_mobility_devices': value.is_eligible_for_power_mobility_devices,
    };
}
